import { gql } from "apollo-boost";

export const GET_ALL_MEET_SESSION_EVENTS = gql`
  query {
    allMeetEvent {
      edges {
        node {
          seqno
          sessionSeqno
          eventId
          externalEventId
          id
          position
          event {
            eventDesc
            distance
            eventId
            facilityType
            noOfRep
            noOfSets
            sportType
            stroke
            tag
            updateSource
          }
        }
      }
    }
  }
`;
export const GET_ALL_EVENTS = gql`
  query {
    allEvent {
      edges {
        node {
          eventId
          distance
          stroke
          sportType
          eventDesc
          noOfSets
          noOfRep
          tag
          sportType
          facilityType
          updateSource
        }
      }
    }
  }
`;
